








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloCommande, AloCommande } from '@/models/alo/AloCommande';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'EditBaseCommande',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseCommande extends Vue {
  
  private original:AloCommande = getDefaultAloCommande()
  private modified:AloCommande = getDefaultAloCommande()
  private showDrawer = false
  private saving = false
    
  edit(item:AloCommande) {
    this.$store.myActions.ADM_COMMANDE_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloCommande(),...item}    
    this.modified = cloneDeep(this.original)
    
    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get commandeStatus() {
    return this.$store.myGetters.commandeStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_COMMANDE_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.commandeStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
